import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Reveal } from '@/components/ui/Reveal';

export function FinalCta() {
  return (
    <section className="relative overflow-hidden px-4 py-24 md:px-6 md:py-32">
      {/* Dunkler Gradient + dezente Karten-Grafik */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-bg-primary via-bg-secondary to-bg-primary" />
        <div className="absolute left-1/2 top-1/2 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-accent-emergency/15 blur-3xl" />
        <svg
          className="absolute inset-0 h-full w-full opacity-[0.07]"
          viewBox="0 0 1200 600"
          preserveAspectRatio="xMidYMid slice"
          aria-hidden
        >
          <g stroke="#94a3b8" strokeWidth="1">
            {Array.from({ length: 18 }).map((_, i) => (
              <line key={`v${i}`} x1={i * 70} y1={0} x2={i * 70 + 30} y2={600} />
            ))}
            {Array.from({ length: 10 }).map((_, i) => (
              <line key={`h${i}`} x1={0} y1={i * 60} x2={1200} y2={i * 60 - 18} />
            ))}
          </g>
        </svg>
      </div>

      <Reveal>
        <div className="relative mx-auto max-w-3xl text-center">
          <h2 className="font-display text-4xl font-bold leading-tight md:text-6xl">
            Bereit für deinen ersten Notruf?
          </h2>
          <p className="mt-4 text-lg text-fg-secondary md:text-xl">
            Keine Anmeldung. Kein Download. Direkt im Browser.
          </p>

          <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/play"
              className="group inline-flex w-full items-center justify-center gap-2 rounded-md bg-accent-emergency px-10 py-5 text-lg font-semibold text-white shadow-md transition hover:bg-accent-emergency-hover hover:shadow-[0_0_48px_rgba(220,38,38,0.55)] sm:w-auto"
            >
              Jetzt spielen
              <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5" />
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
